import React from "react";
import ContentLoader from "react-content-loader";
import { fakeSettings } from "@/constants/constants";

const traceabilityFake = () => {
  return (
    <div className={"container"}>
      <section className="traceability-container">
        <div style={{ margin: "0" }}>
          <ContentLoader
            height="75"
            width="100%"
            viewBox="50 50 100% 100vh"
            {...fakeSettings}
          >
            <rect x="0" y="0" rx="4" ry="4" width="100vw" height="75" />
          </ContentLoader>
        </div>
        <div style={{ marginTop: "10px" }}>
          <ContentLoader
            height="60"
            width="100%"
            viewBox="50 50 100% 100vh"
            {...fakeSettings}
          >
            <rect x="0" y="0" rx="4" ry="4" width="100vw" height="60" />
          </ContentLoader>
        </div>
        <div style={{ marginTop: "10px" }}>
          <ContentLoader
            height="181"
            width="100%"
            viewBox="50 50 100% 100vh"
            {...fakeSettings}
          >
            <rect x="0" y="0" rx="4" ry="4" width="360" height="181" />
          </ContentLoader>
        </div>
        <br/>
        <br/>
        <br/>
        <div style={{ marginTop: "10px" }}>
          <ContentLoader
            height="24"
            width="100%"
            viewBox="50 50 100% 100vh"
            {...fakeSettings}
          >
            <rect x="0" y="0" rx="4" ry="4" width="320" height="24" />
          </ContentLoader>
        </div>
        <div style={{ marginTop: "10px" }}>
          <ContentLoader
            height="24"
            width="100%"
            viewBox="50 50 100% 100vh"
            {...fakeSettings}
          >
            <rect x="0" y="0" rx="4" ry="4" width="280" height="21" />
          </ContentLoader>
        </div>
        <div style={{ marginTop: "5px" }}>
          <ContentLoader
            height="21"
            width="100%"
            viewBox="50 50 100% 100vh"
            {...fakeSettings}
          >
            <rect x="0" y="0" rx="4" ry="4" width="280" height="21" />
          </ContentLoader>
        </div>
        <div style={{ marginTop: "5px" }}>
          <ContentLoader
            height="21"
            width="100%"
            viewBox="50 50 100% 100vh"
            {...fakeSettings}
          >
            <rect x="0" y="0" rx="4" ry="4" width="280" height="21" />
          </ContentLoader>
        </div>

        <div style={{ marginTop: "20px" }}>
          <ContentLoader
            height="24"
            width="100%"
            viewBox="50 50 100% 100vh"
            {...fakeSettings}
          >
            <rect x="0" y="0" rx="4" ry="4" width="320" height="24" />
          </ContentLoader>
        </div>
        <div style={{ marginTop: "5px" }}>
          <ContentLoader
            height="21"
            width="100%"
            viewBox="50 50 100% 100vh"
            {...fakeSettings}
          >
            <rect x="0" y="0" rx="4" ry="4" width="230" height="21" />
          </ContentLoader>
        </div>
        <div style={{ marginTop: "5px" }}>
          <ContentLoader
            height="21"
            width="100%"
            viewBox="50 50 100% 100vh"
            {...fakeSettings}
          >
            <rect x="0" y="0" rx="4" ry="4" width="230" height="21" />
          </ContentLoader>
        </div>
        <div style={{ marginTop: "5px" }}>
          <ContentLoader
            height="21"
            width="100%"
            viewBox="50 50 100% 100vh"
            {...fakeSettings}
          >
            <rect x="0" y="0" rx="4" ry="4" width="200" height="21" />
          </ContentLoader>
        </div>
      </section>

      <style jsx>{`
        .traceability-container {
          display: flex;
          flex-direction: column;
        }
        @media (min-width: 1024px) {
          .traceability-container {
            max-width: 70%;
          }
        }
      `}</style>
    </div>
  );
};

export default traceabilityFake;
